import { Box, Card, Typography, Divider } from "@mui/material";
import { useState } from "react";
import ContactRequestFilters, { ContactFilters } from "./filters";
import ContactRequestsTable from "./table";

const ContactRequestsPage = () => {
  const [filters, setFilters] = useState<ContactFilters>({});

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        maxWidth: "1400px",
        mx: "auto",
        px: { xs: 2, md: 3 },
        py: 2.5,
      }}
    >
      {/* ================= PAGE HEADER ================= */}
      <Box>
        <Typography fontSize={24} fontWeight={800} letterSpacing={-0.3}>
          Contact Requests
        </Typography>
        <Typography fontSize={14} color="text.secondary" mt={0.5}>
          Review, qualify, and manage inbound leads from website forms
        </Typography>
      </Box>

      {/* ================= FILTERS ================= */}
      <ContactRequestFilters onApply={setFilters} />

      {/* ================= TABLE ================= */}
      <Card
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E7ECF3",
          boxShadow: "none",
          bgcolor: "#fff",
        }}
      >
        {/* TABLE HEADER */}
        <Box px={2.25} py={1.75}>
          <Typography fontWeight={700} fontSize={15}>
            Results
          </Typography>
          <Typography fontSize={13} color="text.secondary">
            Showing contact requests matching your filters
          </Typography>
        </Box>

        <Divider sx={{ borderColor: "#EEF2F6" }} />

        {/* TABLE CONTENT */}
        <Box px={1.5}>
          <ContactRequestsTable filters={filters} />
        </Box>
      </Card>
    </Box>
  );
};

export default ContactRequestsPage;
